import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {AccreditationBody, Country, Order, PriceFactor, Scope} from "../../store/state/order.state";
import {environment} from "../../../environments/environment";
import {OrderHistory} from "../../order/components/history/order-history.model";
import {AdditionalQuestionsData} from "../../store/actions/order.actions";
import {EstimateQuestionsForAccBody} from "../../order/resolvers/estimate-questions.resolver";
import {StandardConfiguration} from "../../order/resolvers/standard-configurations-resolver.service";

export class CommonEndpoints {

	constructor(protected http: HttpClient) {
	}

	getOrder(correlationId: string): Observable<Order> {
		const url = `${environment.apiUrl}/order/${correlationId}`;
		return this.http.get<Order>(url, {responseType: "json"});
	}

	getOrderHistory(correlationId: string): Observable<OrderHistory> {
		const url: string = `${environment.apiUrl}/order/${correlationId}/history`;
		return this.http.get<OrderHistory>(url, {observe: "body", responseType: "json", headers: {'Content-Type': 'application/json;charset=UTF-8'}});
	}

	getAdditionalQuestionsDataFor(order: Order): Observable<AdditionalQuestionsData> {
		const standards: string = order.products.map(p => p.standard.name).join(',');
		const country: string = order.clientCountry;
		const url: string = `${environment.apiUrl}/order/additional-questions-data?standards=${standards}&country=${country}`;
		return this.http.get<AdditionalQuestionsData>(url, {
			responseType: "json",
			headers: {'Content-Type': 'application/json;charset=UTF-8'}
		});
	}

	checkServerHealth(): Observable<HttpResponse<any>> {
		let url: string = `${environment.apiUrl}/health`;
		return this.http.get(url, {observe: "response"});
	}

	getAllCountries(): Observable<Country[]> {
		const url: string = `${environment.apiUrl}/countries`;
		return this.http.get<Country[]>(url, {
			responseType: "json",
			headers: {'Content-Type': 'application/json;charset=UTF-8'}
		});
	}

	getEstimateQuestions(accBodies): Observable<EstimateQuestionsForAccBody> {
		const url: string = `${environment.apiUrl}/order/estimate-questions?acc-bodies=${accBodies.join(',')}`;
		return this.http.get<EstimateQuestionsForAccBody>(url, {
			responseType: "json",
			headers: {'Content-Type': 'application/json;charset=UTF-8'}
		})
	}

	getPriceFactors(accreditationBodies: AccreditationBody[]): Observable<{ [accBody: string]: PriceFactor[]}> {
		const url: string = `${environment.apiUrl}/order/price-factors?acc-bodies=${accreditationBodies.join(',')}`;
		return this.http.get<{ [accBody: string]: PriceFactor[]}>(url, {responseType: "json", headers: {'Content-Type': 'application/json;charset=UTF-8'}});
	}

	getSalesPeople(): Observable<string[]> {
		const url: string = `${environment.apiUrl}/order/salespeople`;
		return this.http.get<string[]>(url, {responseType: "json", headers: {'Content-Type': 'application/json;charset=UTF-8'}});
	}

	getScopes(accreditationBodies: AccreditationBody[]): Observable<{ [accBody: string] : Scope[] }> {
		const url: string = `${environment.apiUrl}/scopes?acc-bodies=${accreditationBodies.join(',')}`;
		return this.http.get<{ [accBody: string] : Scope[] }>(url, {responseType: "json", headers: {'Content-Type': 'application/json;charset=UTF-8'}})
	}

	getStandards(): Observable<StandardConfiguration[]> {
		const url: string = `${environment.apiUrl}/standards`;
		return this.http.get<StandardConfiguration[]>(url, {responseType: "json"});
	}

	getCompromisedPasswords(compromisedPasswordsFile: string): Observable<string> {
		return this.http.get(`assets/${compromisedPasswordsFile}`, {responseType: "text", headers: {'Content-Type': 'text/plain'}})
	}

	checkPricingConfigChanged(correlationId: string): Observable<boolean> {
		return this.http.get<boolean>(`${environment.apiUrl}/order/${correlationId}/price-config-changed`)
	}
}
